import React, { useState } from "react";
import styles from "./FloatingButton.module.css";
import { FaPlus } from "react-icons/fa"; // example icon
import Button from "../button/Button";
import MediaLibraryModal from "../mediaLibrary/MediaLibraryModal";
import { useLocation } from "react-router-dom";

const FloatingButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const endpoint = pathSegments[pathSegments.length - 1];
  const handleClick = () => {
    setIsOpen(true);
  };
  return (
    <>
      <Button
        className={styles.fab}
        onClick={handleClick}
        iconRight={<FaPlus />}
      />
      {isOpen ? (
        <MediaLibraryModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          mode={"modal"}
          endpoint={endpoint}
          isFloating={true}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default FloatingButton;
